import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css/pagination";
import Banner from "@/components/bannerSlider/banner/Banner";

import styles from "./BannerSlider.module.scss";


type Props = {
  banners: any[];
  className?: string;
  bannerClassName?: string;
  bannerTexts?: {
    title: string;
    description?: string;
  } | null;
};
const BannerSlider = ({ banners, className = "", bannerClassName = "", bannerTexts }: Props) => {
  const hasMultipleBanners = (banners?.length ?? 0) > 1;

  return (
    <Swiper
      spaceBetween={50}
      slidesPerView={1}
      className={`${styles.slider} ${className}`}
      pagination={hasMultipleBanners ? { clickable: true } : false}
      modules={[Pagination, Autoplay]}
      loop={hasMultipleBanners}
      autoplay={
        hasMultipleBanners
          ? {
              delay: 5000,
              disableOnInteraction: false,
            }
          : false
      }
    >
      {banners &&
        banners.map((e: any, index: number) => {
          return (
            <SwiperSlide className={styles.slider__slide} key={index}>
              <Banner uri={e.uri} className={bannerClassName} bannerTexts={bannerTexts} />
            </SwiperSlide>
          );
        })}
    </Swiper>
  );
};

export default BannerSlider;
